"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

//     NoFlo - Flow-Based Programming for JavaScript
//     (c) 2013-2020 Flowhub UG
//     (c) 2011-2012 Henri Bergius, Nemein
//     NoFlo may be freely distributed under the MIT license
module.exports = /*#__PURE__*/function () {
  function ProcessContext(ip, nodeInstance, port, result) {
    _classCallCheck(this, ProcessContext);

    this.ip = ip;
    this.nodeInstance = nodeInstance;
    this.port = port;
    this.result = result;
    this.scope = this.ip.scope;
    this.activated = false;
    this.deactivated = false;
  }

  _createClass(ProcessContext, [{
    key: "activate",
    value: function activate() {
      // Push a new result value if previous has been sent already

      /* eslint-disable no-underscore-dangle */
      if (this.result.__resolved || this.nodeInstance.outputQ.indexOf(this.result) === -1) {
        this.result = {};
      }

      this.nodeInstance.activate(this);
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      if (!this.result.__resolved) {
        this.result.__resolved = true;
      }

      this.nodeInstance.deactivate(this);
    }
  }]);

  return ProcessContext;
}();